(() => {
  const money = (paise) => new Intl.NumberFormat('en-IN', {
    style: 'currency', currency: 'INR', maximumFractionDigits: 0
  }).format((Number(paise) || 0) / 100);

  const clamp = (value, min = 0, max = 1) => Math.max(min, Math.min(max, value));
  const gaussian = (actual, target, sigma) => Math.exp(-0.5 * Math.pow((actual - target) / sigma, 2));
  const normalise = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9+]+/g, ' ').replace(/\s*\+\s*/g, '+').trim();
  const titleCase = (value) => String(value || '').replace(/_/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
  const compareByMatchScore = (a, b) =>
    b.score - a.score ||
    b.confidence - a.confidence ||
    a.profile.price - b.profile.price ||
    String(a.profile.id).localeCompare(String(b.profile.id));

  const BASE_PROFILE = {
    length: null, width: null, height: null, weight: null,
    form: null, handedness: 'right', handSizes: null, grips: null,
    sensor: null, dpiMax: null, polling: null, connections: null,
    battery: null, buttons: null, surfaces: ['cloth', 'hard'],
    sourceQuality: 0.35, consistency: 0.50, family: null, note: null,
    hasFitProfile: false
  };

  const PROFILES = [
    { match: ['dragonfly x1 air+', 'blazing sky x1 air+'], data: { family: 'ATK X1 Air+', length: 127, width: 64, height: 40, weight: 48, form: 'symmetrical', handSizes: ['medium','large'], grips: ['relaxed_claw','aggressive_claw','palm'], sensor: 'PAW3955', dpiMax: 50000, polling: 8000, connections: ['wired','wireless24'], battery: 300 } },
    { match: ['dragonfly a9 mini+', 'atk a9 mini+'], data: { family: 'ATK A9 Mini+', length: 118.4, width: 61.2, height: 38.6, weight: 39, form: 'symmetrical', handSizes: ['small','medium'], grips: ['palm','relaxed_claw','aggressive_claw','fingertip'], sensor: 'PAW3955', dpiMax: 50000, polling: 8000, connections: ['wired','wireless24'], battery: 200 } },
    { match: ['dragonfly a9 se', 'dragonfly a9 2.0', 'a9 series se 2.0', 'a9 series se 2 0'], data: { family: 'ATK A9 SE / 2.0', length: 125, width: 64, height: 40, weight: 53, form: 'symmetrical', handSizes: ['medium','large'], grips: ['palm','relaxed_claw','aggressive_claw','fingertip'], sensor: 'PAW3395 SE', dpiMax: 26000, polling: 1000, connections: ['wired','wireless24','bluetooth'], battery: 500 } },
    { match: ['eweadn q1'], data: { family: 'EWEADN Q1', form: 'ergonomic', sensor: 'PAW3065', connections: ['wireless24','bluetooth'], battery: 400, sourceQuality: 0.58 } },
    { match: ['mchose k7 v2'], data: { family: 'MCHOSE K7 V2', length: 127.1, width: 63.8, height: 39.8, weight: 59, form: null, handSizes: ['medium','large'], grips: ['palm','relaxed_claw','aggressive_claw'], polling: 8000, connections: ['wired','wireless24','bluetooth'], battery: 500, consistency: 0.65, note: 'Sensor and DPI vary by Pro+ and Ultra+ model; the manufacturer describes its shape inconsistently.' } },
    { match: ['mchose k7 ultra'], data: { family: 'MCHOSE K7 Ultra', length: 127.3, width: 63.8, height: 39.9, weight: 59, form: 'symmetrical', handSizes: ['medium','large'], grips: ['palm','relaxed_claw','aggressive_claw'], sensor: 'PAW3950', dpiMax: 42000, polling: 8000, connections: ['wired','wireless24'], battery: 500 } },
    { match: ['atk zero extreme', 'atk zero', 'blazing sky zero'], data: { family: 'ATK ZERO', length: 120.1, width: 63.2, height: 38.1, weight: 42, form: 'symmetrical', handSizes: ['small','medium'], grips: ['relaxed_claw','aggressive_claw','fingertip'], sensor: 'PAW3950', dpiMax: 42000, polling: 8000, connections: ['wired','wireless24'], battery: 300 } },
    { match: ['a9 nb ultra', 'a9 nb ulltra'], data: { family: 'ATK A9 NB Ultra', length: 125, width: 63.5, height: 40, weight: 56, form: 'symmetrical', handSizes: ['medium','large'], grips: ['palm','relaxed_claw','aggressive_claw','fingertip'], sensor: 'PAW3950', dpiMax: 42000, polling: 8000, connections: ['wired','wireless24'], battery: 800 } },
    { match: ['akitsu'], data: { family: 'Akitsu', weight: 40, form: 'symmetrical', sensor: 'PAW3950', dpiMax: 30000, polling: 8000, connections: ['wired','wireless24'], sourceQuality: 0.68 } },
    { match: ['attack shark r6'], data: { family: 'Attack Shark R6', length: 118, width: 60, height: 38, weight: 39, form: 'symmetrical', handSizes: ['small','medium'], grips: ['relaxed_claw','aggressive_claw','fingertip'], sensor: 'PAW3950 MAX', dpiMax: 42000, polling: 8000, connections: ['wired','wireless24','bluetooth'] } },
    { match: ['mchose l7 pro'], data: { family: 'MCHOSE L7 Pro', length: 115.62, width: 60.61, height: 36.04, weight: 39, form: 'symmetrical', handSizes: ['small'], grips: ['relaxed_claw','aggressive_claw','fingertip'], sensor: 'PAW3395', dpiMax: 26000, polling: 8000, connections: ['wired','wireless24','bluetooth'], battery: 250, consistency: 0.66, note: 'Published switch specifications conflict between sources.' } },
    { match: ['atk ghost', 'blazing sky ghost'], data: { family: 'ATK Ghost', length: 121, width: 61.3, height: 38, weight: 48, form: 'symmetrical', handSizes: ['small','medium'], grips: ['palm','relaxed_claw','aggressive_claw','fingertip'], sensor: 'PAW3950', dpiMax: 42000, polling: 8000, connections: ['wired','wireless24','bluetooth'], battery: 300 } },
    { match: ['x1 v2'], data: { family: 'ATK X1 V2', length: 127, width: 64, height: 40, weight: 51, form: 'symmetrical', handSizes: ['medium','large'], grips: ['palm','relaxed_claw','aggressive_claw'], sensor: 'PAW3950', dpiMax: 42000, polling: 8000, connections: ['wired','wireless24'], battery: 500, consistency: 0.72, note: 'Weight, battery and Bluetooth support vary by model.' } },
    { match: ['f1 v2'], data: { family: 'ATK F1 V2', length: 118.2, width: 62.4, height: 38.8, weight: 46, form: 'symmetrical', handSizes: ['small','medium'], grips: ['relaxed_claw','aggressive_claw','fingertip'], sensor: 'PAW3950', dpiMax: 42000, polling: 8000, connections: ['wired','wireless24'], battery: 500, consistency: 0.72, note: 'Weight, battery and Bluetooth support vary by model.' } },
    { match: ['vxe r1'], data: { family: 'VXE R1', length: 120.6, width: 64.1, height: 37.6, weight: 51, form: 'symmetrical', handSizes: ['small','medium'], grips: ['relaxed_claw','aggressive_claw','fingertip'], sensor: 'PAW3395', dpiMax: 26000, polling: 4000, connections: ['wired','wireless24'], battery: 385, consistency: 0.70, note: 'Sensor, polling rate, battery and connection support vary by model.' } },
    { match: ['dragonfly a9 series', 'a9 ultimate', 'a9 air'], data: { family: 'ATK A9', length: 125, width: 63.5, height: 40, weight: 51, form: 'symmetrical', handSizes: ['medium','large'], grips: ['palm','relaxed_claw','aggressive_claw','fingertip'], sensor: 'PAW3950', dpiMax: 42000, polling: 8000, connections: ['wired','wireless24'], battery: 500, consistency: 0.72, note: 'Specifications vary by Ultimate, Air and Air+ model.' } },
    { match: ['eweadn z7'], data: { family: 'EWEADN Z7', weight: 51, form: 'symmetrical', handSizes: ['small','medium'], grips: ['relaxed_claw','aggressive_claw','fingertip'], sensor: 'PAW3950', dpiMax: 42000, polling: 8000, connections: ['wired','wireless24','bluetooth'], battery: 500, consistency: 0.58, note: 'Published revisions conflict; verify the exact model before ordering.' } },
    { match: ['attack shark r5 ultra'], data: { family: 'Attack Shark R5 Ultra', length: 119.5, width: 61, height: 36.3, weight: 39, form: 'symmetrical', handSizes: ['small','medium'], grips: ['aggressive_claw','fingertip'], sensor: 'PAW3950 MAX', dpiMax: 42000, polling: 8000, connections: ['wired','wireless24','bluetooth'] } },
    { match: ['attack shark r11 ultra'], data: { family: 'Attack Shark R11 Ultra', length: 124, width: 65.5, height: 38, weight: 49, form: 'symmetrical', handSizes: ['medium','large'], grips: ['palm','relaxed_claw'], sensor: 'PAW3950 MAX', dpiMax: 42000, polling: 8000, connections: ['wired','wireless24','bluetooth'] } },
    { match: ['attack shark r2'], data: { family: 'Attack Shark R2', length: 117.6, width: 61.8, height: 38.9, weight: 45, form: 'symmetrical', handSizes: ['small','medium'], grips: ['relaxed_claw','aggressive_claw','fingertip'], sensor: 'PAW3950', dpiMax: 42000, polling: 8000, connections: ['wired','wireless24','bluetooth'] } },
    { match: ['attack shark r3'], data: { family: 'Attack Shark R3', length: 119, width: 61, height: 36, weight: 46, form: 'symmetrical', handSizes: ['small','medium'], grips: ['aggressive_claw','fingertip'], sensor: 'PAW3395', dpiMax: 26000, polling: 8000, connections: ['wired','wireless24','bluetooth'], battery: 200 } },
    { match: ['attack shark v8'], data: { family: 'Attack Shark V8', length: 126.37, width: 67.8, height: 40.7, weight: 59, form: 'ergonomic', handSizes: ['medium','large'], grips: ['palm','relaxed_claw','aggressive_claw'], sensor: 'PAW3950 MAX', dpiMax: 42000, polling: 8000, connections: ['wired','wireless24','bluetooth'], battery: 500 } },
    { match: ['mchose a5 v3'], data: { family: 'MCHOSE A5 V3', length: 121.6, width: 61.5, height: 37.7, weight: 56, form: 'symmetrical', handSizes: ['small','medium'], grips: ['palm','relaxed_claw','aggressive_claw','fingertip'], sensor: 'PAW3395', dpiMax: 26000, polling: 8000, connections: ['wired','wireless24','bluetooth'], battery: 500 } }
  ];

  function profileFor(item) {
    const haystack = normalise(`${item.productTitle} ${item.variantTitle}`);
    const found = PROFILES.find((entry) => entry.match.some((term) => haystack.includes(normalise(term))));
    const profile = Object.assign({}, BASE_PROFILE, found ? found.data : {}, item);
    profile.hasFitProfile = Boolean(found);
    if (found && found.data.sourceQuality == null) profile.sourceQuality = 0.82;
    if (found && found.data.consistency == null) profile.consistency = 0.86;
    profile.connections = profile.connections ? [...profile.connections] : null;
    profile.grips = profile.grips ? [...profile.grips] : null;
    profile.handSizes = profile.handSizes ? [...profile.handSizes] : null;
    profile.surfaces = profile.surfaces ? [...profile.surfaces] : null;
    profile.family = profile.family || item.productTitle;
    return profile;
  }

  class MouseFinder {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('[data-finder-form]');
      this.catalog = JSON.parse(root.querySelector('[data-mouse-catalog]').textContent || '[]').map(profileFor);
      this.stepIndex = 0;
      this.results = [];
      this.filteredResults = [];
      this.selected = new Map();
      this.bind();
      this.refreshSteps();
      this.updateProfileSummary();
    }

    bind() {
      this.root.querySelector('[data-finder-next]').addEventListener('click', () => this.move(1));
      this.root.querySelector('[data-finder-back]').addEventListener('click', () => this.move(-1));
      this.form.addEventListener('submit', (event) => { event.preventDefault(); this.recommend(); });
      this.form.addEventListener('input', () => this.updateProfileSummary());
      this.root.querySelector('[name="budget"]').addEventListener('input', (event) => {
        this.root.querySelector('[data-budget-output]').textContent = money(Number(event.target.value) * 100);
      });
      this.root.querySelector('[data-no-ruler]').addEventListener('click', () => {
        const panel = this.root.querySelector('[data-no-ruler-panel]');
        panel.hidden = !panel.hidden;
        this.root.querySelector('[data-no-ruler]').classList.toggle('is-active', !panel.hidden);
        this.updateProfileSummary();
      });
      this.root.querySelectorAll('[data-need]').forEach((button) => button.addEventListener('click', () => {
        const next = { none: 'prefer', prefer: 'required', required: 'none' }[button.dataset.state];
        button.dataset.state = next;
        button.querySelector('span').textContent = next === 'none' ? "Don't care" : titleCase(next);
      }));
      this.root.querySelector('[data-edit-profile]').addEventListener('click', () => {
        this.root.querySelector('[data-finder-results]').hidden = true;
        this.root.querySelector('.mouse-finder__workspace').hidden = false;
        this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      this.root.querySelectorAll('[data-result-filter]').forEach((button) => button.addEventListener('click', () => this.applyResultFilter(button)));
      this.root.querySelector('[data-open-compare]').addEventListener('click', () => this.openCompare());
      this.root.querySelector('[data-close-compare]').addEventListener('click', () => this.root.querySelector('[data-compare-dialog]').close());
      this.root.querySelector('[data-compare-dialog]').addEventListener('click', (event) => {
        if (event.target === event.currentTarget) event.currentTarget.close();
      });
    }

    get steps() {
      return [...this.root.querySelectorAll('[data-step]')];
    }

    refreshSteps() {
      const steps = this.steps;
      this.root.querySelectorAll('[data-step]').forEach((step) => step.classList.remove('is-active'));
      steps[this.stepIndex].classList.add('is-active');
      const current = this.stepIndex + 1;
      this.root.querySelector('[data-progress-label]').textContent = `Step ${current} of ${steps.length}`;
      this.root.querySelector('[data-progress-bar]').style.width = `${(current / steps.length) * 100}%`;
      this.root.querySelector('[data-finder-back]').disabled = this.stepIndex === 0;
      const last = this.stepIndex === steps.length - 1;
      this.root.querySelector('[data-finder-next]').hidden = last;
      this.root.querySelector('[data-finder-submit]').hidden = !last;
    }

    move(direction) {
      if (direction > 0 && !this.validStep()) return;
      this.stepIndex = clamp(this.stepIndex + direction, 0, this.steps.length - 1);
      this.refreshSteps();
      this.root.querySelector('.mouse-finder__quiz').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    validStep() {
      const step = this.steps[this.stepIndex];
      if (step.dataset.step !== 'hand') return true;
      const input = this.form.elements.handLength;
      if (this.root.querySelector('[data-no-ruler-panel]').hidden && (!input.value || Number(input.value) < 130 || Number(input.value) > 250)) {
        input.setCustomValidity('Enter a hand length between 130 and 250 mm.');
        input.reportValidity();
        input.setCustomValidity('');
        return false;
      }
      return true;
    }

    answers() {
      const data = new FormData(this.form);
      const connections = {};
      this.root.querySelectorAll('[data-need]').forEach((button) => { connections[button.dataset.need] = button.dataset.state; });
      return {
        handLength: Number(data.get('handLength')) || null,
        handWidth: Number(data.get('handWidth')) || null,
        estimatedHand: !this.root.querySelector('[data-no-ruler-panel]').hidden,
        currentFit: data.get('currentFit'), grip: data.get('grip'), handedness: data.get('handedness'),
        shape: data.get('shape'), connections, weight: data.get('weight'),
        budget: Number(data.get('budget')), budgetMode: data.get('budgetMode'),
        polling: 0, buttons: 0, surface: 'any', portability: 0
      };
    }

    updateProfileSummary() {
      const answer = this.answers();
      const gripLabels = { palm: 'Palm', claw: 'Claw', fingertip: 'Fingertip', unsure: 'Mixed / unsure' };
      const weightLabels = { under50: 'Under 50 g', '50to65': '50–65 g', '66to80': '66–80 g', over80: 'Over 80 g', any: 'No preference' };
      const hand = answer.estimatedHand ? `Estimated (${titleCase(answer.currentFit)})` : `${answer.handLength || '—'} × ${answer.handWidth || '—'} mm`;
      this.root.querySelector('[data-profile-summary]').innerHTML = [
        ['Hand', hand], ['Grip', gripLabels[answer.grip]],
        ['Weight', weightLabels[answer.weight]], ['Budget', `${money(answer.budget * 100)} ${answer.budgetMode}`]
      ].map(([term, value]) => `<div><dt>${term}</dt><dd>${value}</dd></div>`).join('');
    }

    eligibility(profile, answer) {
      const failures = [];
      const verify = [];
      if (!profile.available) failures.push('not currently available');
      if (!profile.hasFitProfile) failures.push('fit specifications not verified');
      if (answer.shape !== 'any') {
        if (profile.form !== answer.shape) failures.push(`not a verified ${answer.shape} mouse`);
      }
      if (answer.handedness !== 'right') {
        if (!profile.handedness) verify.push('handedness');
        else if (!['both', answer.handedness].includes(profile.handedness)) failures.push(`not verified for ${answer.handedness}-hand use`);
      }
      if (answer.budgetMode === 'strict' && profile.price / 100 > answer.budget) failures.push('over the strict budget');
      const connectionKeys = { wireless24: 'wireless24', bluetooth: 'bluetooth', wired: 'wired' };
      Object.entries(answer.connections).forEach(([key, state]) => {
        if (state !== 'required') return;
        if (!profile.connections) failures.push(`${key} connection not verified`);
        else if (!profile.connections.includes(connectionKeys[key])) failures.push(`missing required ${key === 'wireless24' ? '2.4 GHz' : key}`);
      });
      if (answer.polling) {
        if (profile.polling == null) failures.push('polling rate not verified');
        else if (profile.polling < answer.polling) failures.push(`below ${answer.polling.toLocaleString('en-IN')} Hz`);
      }
      if (answer.buttons) {
        if (profile.buttons == null) failures.push('button count not verified');
        else if (profile.buttons < answer.buttons) failures.push(`fewer than ${answer.buttons} buttons`);
      }
      if (answer.surface === 'glass') {
        if (!profile.surfaces || !profile.surfaces.includes('glass')) failures.push('glass-pad support is not verified');
      }
      return { eligible: failures.length === 0, failures, verify: [...new Set(verify)] };
    }

    fitComponent(profile, answer) {
      let handLength = answer.handLength;
      let handWidth = answer.handWidth;
      if (answer.estimatedHand) {
        handLength = answer.currentFit === 'small' ? 195 : answer.currentFit === 'large' ? 160 : 178;
        handWidth = null;
      }
      let targetLength = handLength < 160 ? 110 : handLength < 173 ? 117.5 : handLength < 196 ? 122.5 : handLength < 214 ? 127.5 : 132;
      const lengthOffset = { palm: 3, claw: -1.5, fingertip: -6, unsure: 0 }[answer.grip] || 0;
      targetLength += lengthOffset;
      const values = [];
      if (profile.length != null) values.push([gaussian(profile.length, targetLength, answer.grip === 'unsure' ? 11 : 8), 0.45]);
      if (profile.width != null && handWidth) values.push([gaussian(profile.width, handWidth * 0.70, 6.5), 0.25]);
      if (profile.height != null) {
        const heightTarget = { palm: 40, claw: 38, fingertip: 36, unsure: 38 }[answer.grip];
        values.push([gaussian(profile.height, heightTarget, answer.grip === 'unsure' ? 7 : 5), 0.15]);
      }
      if (profile.grips) {
        const gripMatches = answer.grip === 'claw'
          ? profile.grips.some((grip) => grip === 'relaxed_claw' || grip === 'aggressive_claw')
          : profile.grips.includes(answer.grip);
        values.push([answer.grip === 'unsure' || gripMatches ? 1 : 0.48, 0.15]);
      }
      if (!values.length) return null;
      const weight = values.reduce((sum, item) => sum + item[1], 0);
      return values.reduce((sum, item) => sum + item[0] * item[1], 0) / weight;
    }

    componentScores(profile, answer) {
      const fit = this.fitComponent(profile, answer);
      const performanceParts = [];
      if (profile.polling != null) performanceParts.push(clamp(Math.log2(Math.max(profile.polling, 125) / 125) / 6));
      if (profile.dpiMax != null) performanceParts.push(clamp(profile.dpiMax / 42000));
      const performance = performanceParts.length ? performanceParts.reduce((a, b) => a + b, 0) / performanceParts.length : null;
      const weightRanges = { under50: [0, 49], '50to65': [50, 65], '66to80': [66, 80], over80: [81, 130] };
      let weight = null;
      if (answer.weight !== 'any' && profile.weight != null) {
        const [min, max] = weightRanges[answer.weight];
        weight = profile.weight >= min && profile.weight <= max ? 1 : clamp(1 - Math.min(Math.abs(profile.weight - min), Math.abs(profile.weight - max)) / 30);
      }
      const preferences = Object.entries(answer.connections).filter(([, state]) => state !== 'none');
      let connection = null;
      if (preferences.length && profile.connections) {
        connection = preferences.reduce((sum, [key, state]) => {
          const wanted = key === 'wireless24' ? 'wireless24' : key;
          return sum + (profile.connections.includes(wanted) ? 1 : state === 'required' ? 0 : 0.35);
        }, 0) / preferences.length;
      }
      let battery = profile.battery == null ? null : clamp(profile.battery / 800);
      if (answer.portability && profile.weight != null) battery = battery == null ? clamp(1 - (profile.weight - 35) / 60) : (battery + clamp(1 - (profile.weight - 35) / 60)) / 2;
      const price = profile.price / 100;
      const budget = price <= answer.budget ? 1 : answer.budgetMode === 'strict' ? 0 : clamp(1 - (price - answer.budget) / Math.max(answer.budget, 1));
      let surface = null;
      if (answer.surface !== 'any') surface = profile.surfaces ? (profile.surfaces.includes(answer.surface) ? 1 : 0.25) : null;
      const buttons = answer.buttons ? (profile.buttons == null ? null : clamp(profile.buttons / answer.buttons)) : null;
      return { fit, performance, weight, connection, buttons, battery, budget, surface };
    }

    score(profile, answer) {
      const eligibility = this.eligibility(profile, answer);
      if (!eligibility.eligible) return { profile, eligibility, excluded: true };
      const components = this.componentScores(profile, answer);
      const weights = { fit: 30, performance: 20, weight: 12, connection: 10, battery: 7, budget: 7 };
      let earned = 0;
      let possible = 0;
      let knownWeight = 0;
      Object.entries(weights).forEach(([key, weightValue]) => {
        possible += weightValue;
        if (components[key] != null) { earned += components[key] * weightValue; knownWeight += weightValue; }
      });

      const utility = possible ? (earned + (possible - knownWeight) * 0.5) / possible : 0;
      const coverage = possible ? knownWeight / possible : 0;
      const fitEvidence = [profile.length, profile.width, profile.height, profile.grips].filter((value) => value != null).length / 4;
      const confidence = clamp(0.45 * coverage + 0.30 * profile.sourceQuality + 0.15 * fitEvidence + 0.10 * profile.consistency - eligibility.verify.length * 0.04);
      const score = clamp(utility - 0.08 * (1 - confidence));
      return { profile, eligibility, components, confidence, utility, score, excluded: false };
    }

    recommend() {
      if (!this.validStep()) return;
      const answer = this.answers();
      const scored = this.catalog.map((profile) => this.score(profile, answer));
      const eligible = scored.filter((item) => !item.excluded).sort(compareByMatchScore);
      this.results = eligible.slice(0, 10);
      this.excluded = scored.filter((item) => item.excluded);
      this.annotateResults();
      this.renderResults(this.results);
      this.root.querySelector('.mouse-finder__workspace').hidden = true;
      const results = this.root.querySelector('[data-finder-results]');
      results.hidden = false;
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    annotateResults() {
      if (!this.results.length) return;
      const lowest = Math.min(...this.results.map((item) => item.profile.price));
      const lightest = Math.min(...this.results.map((item) => item.profile.weight == null ? Infinity : item.profile.weight));
      this.results.forEach((item, index) => {
        item.badges = [];
        if (index === 0) item.badges.push('Best overall match');
        if (item.profile.price === lowest) item.badges.push('Best value');
        if (item.profile.weight === lightest) item.badges.push('Lightest match');
        if (item.profile.connections && item.profile.connections.includes('bluetooth')) item.badges.push('Bluetooth');
      });
    }

    applyResultFilter(button) {
      this.root.querySelectorAll('[data-result-filter]').forEach((candidate) => candidate.classList.toggle('is-active', candidate === button));
      const filter = button.dataset.resultFilter;
      const filterLabels = { value: 'best-value', light: 'under-50-g', bluetooth: 'Bluetooth' };
      const list = this.results.filter((item) => {
        if (filter === 'value') return item.badges.includes('Best value') || item.profile.price / 100 <= this.answers().budget * 0.75;
        if (filter === 'light') return item.profile.weight != null && item.profile.weight < 50;
        if (filter === 'bluetooth') return item.profile.connections && item.profile.connections.includes('bluetooth');
        return true;
      });
      this.renderResults(list, true, filter === 'all' ? null : filterLabels[filter]);
    }

    renderResults(list, resetSelection = true, emptyFilter = null) {
      const cards = this.root.querySelector('[data-result-cards]');
      const noMatch = this.root.querySelector('[data-no-match]');
      const filters = this.root.querySelector('[data-result-filters]');
      if (resetSelection) { this.selected.clear(); this.updateCompareBar(); }
      if (!list.length) {
        cards.innerHTML = '';
        filters.hidden = !emptyFilter;
        noMatch.hidden = false;
        if (emptyFilter) {
          const readableFilter = emptyFilter === 'under-50-g' ? 'under 50 g' : emptyFilter === 'best-value' ? 'best-value' : emptyFilter;
          noMatch.innerHTML = `<p class="mouse-finder__eyebrow">Nothing in this filter</p><h3>No ${readableFilter} matches in your shortlist.</h3><p>Your other ranked recommendations are still available. Return to the complete list or adjust your answers if this feature is essential.</p><div class="mouse-finder__no-match-actions"><button type="button" data-no-match-all>Show all matches</button><button type="button" data-no-match-edit>Edit answers</button></div>`;
          noMatch.querySelector('[data-no-match-all]').addEventListener('click', () => this.root.querySelector('[data-result-filter="all"]').click());
          noMatch.querySelector('[data-no-match-edit]').addEventListener('click', () => this.root.querySelector('[data-edit-profile]').click());
          this.root.querySelector('[data-results-title]').textContent = `No ${readableFilter} matches`;
          this.root.querySelector('[data-results-copy]').textContent = 'Your complete ranked shortlist is still available.';
        } else {
          noMatch.innerHTML = `<p class="mouse-finder__eyebrow">No exact match yet</p><h3>Let’s adjust one thing.</h3><p>We couldn’t find an in-stock mouse that meets every selected requirement. Review your shape, connection or budget choices to open up more suitable matches.</p><div class="mouse-finder__no-match-actions"><button type="button" data-no-match-edit>Review my answers</button></div>`;
          noMatch.querySelector('[data-no-match-edit]').addEventListener('click', () => this.root.querySelector('[data-edit-profile]').click());
          this.root.querySelector('[data-results-title]').textContent = 'No exact match yet';
          this.root.querySelector('[data-results-copy]').textContent = 'A small change to your answers may reveal a better fit.';
        }
        return;
      }
      noMatch.hidden = true;
      filters.hidden = false;
      this.root.querySelector('[data-results-title]').textContent = 'Best matches for you';
      this.root.querySelector('[data-results-copy]').textContent = `${list.length} in-stock variant${list.length === 1 ? '' : 's'} ranked by fit, requirements and data confidence.`;
      cards.innerHTML = list.map((item, index) => {
        const profile = item.profile;
        const confidenceLabel = item.confidence >= 0.82 ? 'High confidence' : item.confidence >= 0.62 ? 'Medium confidence' : 'Low confidence';
        const variant = profile.variantTitle && profile.variantTitle !== 'Default Title' ? `<span>${profile.variantTitle}</span>` : '';
        return `<article class="mouse-match" data-result-id="${profile.id}">
          <div class="mouse-match__media">
            <span class="mouse-match__rank">${String(index + 1).padStart(2, '0')}</span>
            <img src="${profile.image}" alt="${profile.productTitle.replace(/"/g, '&quot;')}" loading="lazy">
            <span class="mouse-match__score"><strong>${Math.round(item.score * 100)}</strong><small>match</small></span>
          </div>
          <div class="mouse-match__body">
            <div class="mouse-match__badges">${item.badges.slice(0, 2).map((badge) => `<span>${badge}</span>`).join('')}</div>
            <p class="mouse-match__vendor">${profile.vendor}</p><h3>${profile.productTitle}</h3>${variant}
            <div class="mouse-match__specs">
              <span>${profile.weight ? `${profile.weight} g` : 'Weight unverified'}</span>
              <span>${profile.length ? `${profile.length} × ${profile.width || '?'} × ${profile.height || '?'} mm` : 'Size unverified'}</span>
              <span>${profile.polling ? `${profile.polling.toLocaleString('en-IN')} Hz` : 'Polling unverified'}</span>
            </div>
            <div><strong class="mouse-match__price">${money(profile.price)}</strong><span class="mouse-match__confidence">${confidenceLabel}</span></div>
            <div class="mouse-match__actions"><a href="${profile.url}">View product</a><button class="mouse-match__compare-toggle" type="button" data-compare-item="${profile.id}" aria-label="Add ${profile.productTitle.replace(/"/g, '&quot;')} to comparison">+</button></div>
          </div>
        </article>`;
      }).join('');
      cards.querySelectorAll('[data-compare-item]').forEach((button) => button.addEventListener('click', () => this.toggleCompare(button)));
    }

    toggleCompare(button) {
      const id = String(button.dataset.compareItem);
      const adding = !button.classList.contains('is-selected');
      if (adding) {
        if (this.selected.size >= 4) return;
        const item = this.results.find((result) => String(result.profile.id) === id);
        if (item) { this.selected.set(id, item); button.classList.add('is-selected'); button.textContent = '✓'; }
      } else { this.selected.delete(id); button.classList.remove('is-selected'); button.textContent = '+'; }
      this.updateCompareBar();
    }

    updateCompareBar() {
      const bar = this.root.querySelector('[data-compare-bar]');
      bar.hidden = this.selected.size < 2;
      this.root.querySelector('[data-compare-count]').textContent = this.selected.size;
    }

    openCompare() {
      const items = [...this.selected.values()];
      if (items.length < 2) return;
      const rows = [
        ['Match', (item) => `${Math.round(item.score * 100)}%`], ['Confidence', (item) => `${Math.round(item.confidence * 100)}%`],
        ['Dimensions', (item) => item.profile.length ? `${item.profile.length} × ${item.profile.width || '?'} × ${item.profile.height || '?'} mm` : 'Not verified'],
        ['Weight', (item) => item.profile.weight ? `${item.profile.weight} g` : 'Not verified'],
        ['Sensor', (item) => item.profile.sensor || 'Not verified'], ['Polling', (item) => item.profile.polling ? `${item.profile.polling.toLocaleString('en-IN')} Hz` : 'Not verified'],
        ['Connections', (item) => item.profile.connections ? item.profile.connections.map((value) => value === 'wireless24' ? '2.4 GHz' : titleCase(value)).join(', ') : 'Not verified'],
        ['Battery', (item) => item.profile.battery ? `${item.profile.battery} mAh` : 'Not verified'], ['Price', (item) => money(item.profile.price)]
      ];
      this.root.querySelector('[data-compare-table]').innerHTML = `<table><thead><tr><th>Specs</th>${items.map((item) => `<th><img src="${item.profile.image}" alt=""><b>${item.profile.productTitle}</b></th>`).join('')}</tr></thead><tbody>${rows.map(([label, getter]) => `<tr><th>${label}</th>${items.map((item) => `<td>${getter(item)}</td>`).join('')}</tr>`).join('')}</tbody></table>`;
      this.root.querySelector('[data-compare-dialog]').showModal();
    }
  }

  document.querySelectorAll('[data-mouse-finder]').forEach((root) => new MouseFinder(root));
})();
